import "./style.scss";

const Documents = () => {
  return <div>Documents</div>;
};

export default Documents;
